import type { JSX } from 'react';

import { $convertFromMarkdownString } from '@lexical/markdown';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import * as React from 'react';

import { PLAYGROUND_TRANSFORMERS } from '../MarkdownTransformers';

export default function SetContentPlugin({
  onSetContent,
  shouldPreserveNewLinesInMarkdown = false,
}: {
  onSetContent: React.MutableRefObject<(content: string) => void>;
  shouldPreserveNewLinesInMarkdown?: boolean;
}): JSX.Element {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    const setContent = (content: string) => {
      editor.update(() => {
        const root = $getRoot();
        root.clear();
        $convertFromMarkdownString(
          content,
          PLAYGROUND_TRANSFORMERS,
          root,
          shouldPreserveNewLinesInMarkdown,
        );

        // Position cursor at the end of the content
        root.selectEnd();
      });
    };

    // Assign the setContent function to the ref
    onSetContent.current = setContent;
  }, [editor, onSetContent, shouldPreserveNewLinesInMarkdown]);

  return <></>;
}
